import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import { AxiosError } from "axios";
import dayjs from "dayjs";
// import routesName from "../../constants/routesName";

// get all hospital Departments
export const getAllDepartmentsList = createAsyncThunk(
  "get/all-department-list",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      fromDate: moment.Moment | null | string;
      toDate: moment.Moment | null | string;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `CMMIS/cmmis/HospitalListByDepartment?Country=${data.country}&State=${data.state
        }&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli
        }&fromDate=${data.fromDate}&toDate=${data.toDate}&page=${data.page + 1
        }&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords
        }&order=${data.order}&orderBy=${data.orderBy}${data.searchQuery ?? ""}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

// get all hospital Diagnosis
export const getAllDiagnosisList = createAsyncThunk(
  "get/all-diagnosis-list",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      fromDate: moment.Moment | null | string;
      toDate: moment.Moment | null | string;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `CMMIS/ccmis/HospitalListByDiagnosis?Country=${data.country}&State=${data.state
        }&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli
        }&fromDate=${data.fromDate}&toDate=${data.toDate}&page=${data.page + 1
        }&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords
        }&order=${data.order}&orderBy=${data.orderBy}${data.searchQuery ?? ""}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

//new hosptials api

export const getNewHospitalsGraphData = createAsyncThunk(
  "get/new-hospitals-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: number;
      fromDate: moment.Moment | null | string;
      toDate: moment.Moment | null | string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/NewHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}&fromDate=${data.fromDate}&toDate=${data.toDate}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
//////////////////////
export interface OccupiedBedData {
  patientType: "IP" | "OP";
  location: string;
  month: string;
  year: number;
  occupiedBeds: number;
}

export interface OccupiedBedApiResponse {
  success: boolean;
  message: string;
  data: OccupiedBedData[];
  count: number | null;
  error: any;
}

export const getHospitalsPatientTypeOccupiedGraphData = createAsyncThunk<
  OccupiedBedApiResponse,   // ✅ RETURN TYPE
  {
    country: string;
    state: string;
    district: string;
    taluk: string;
    hobli: string;
    serviceType: number;
    fromDate: moment.Moment | null | string;
    toDate: moment.Moment | null | string;
  }
>(

  "get/hospitals-patient-type-occupied-graph-data",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.get(
        `/CMMIS/NewHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}&fromDate=${data.fromDate}&toDate=${data.toDate}`
      );

      // TEMP mocked response (typed!)
      return {
        success: true,
        message: "occupied bed data retrieved successfully",
        data: [
          {
            patientType: "IP",
            location: "ICU",
            month: "Jan",
            year: 2025,
            occupiedBeds: 120,
          },
          {
            patientType: "IP",
            location: "Ward",
            month: "Feb",
            year: 2025,
            occupiedBeds: 90,
          },
          {
            patientType: "OP",
            location: "General OPD",
            month: "Jan",
            year: 2025,
            occupiedBeds: 60,
          },
        ],
        count: null,
        error: null,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


//////////////////////

export const getReasonsGraphData = createAsyncThunk(
  "get/reasons-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/cmmis/RegionWiseActiveHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

/////////////////////////

export const getProductAndPlanGraphData = createAsyncThunk(
  "get/product-and-plan-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/ccmis/ProductAndPlanWiseActiveHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

/////////////
export const getBedSizeGraphData = createAsyncThunk(
  "get/bed-size-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/ccmis/ActiveHospitalsByBedSize?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

///////////////////////////////
export const getSpecialityGraphData = createAsyncThunk(
  "get/Speciality-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/ccmis/ActiveHospitalsBySpeciality?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);

export const getPatientDetailsDepartmentsGraphData = createAsyncThunk(
  "get/patient-details-departments-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
      fromDate: any;
      toDate: any;
      hospitals: any;
      hospitalId?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post(
        `/CMMIS/cmmis/PatientDetailsDepartments?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}&fromDate=${data.fromDate}&toDate=${data.toDate}&hospitals=${data.hospitalId || ""}`,
        data?.hospitals
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);


export const getPatientDepartmentData = async (
  fromDate: any,
  toDate: any,
  hospitalId: any,
  countryid?: any,
  stateid?: any,
  districtid?: any,
  talukid?: any,
  hobliid?: any,
  all?: boolean,
) => {
  try {
    if (!hospitalId) {
      return null;
    }
    const startDate = dayjs(fromDate).format("YYYY-MM-DD");
    const enddate = dayjs(toDate).format("YYYY-MM-DD");
    const params = new URLSearchParams({
      startdate: startDate,
      enddate: enddate,
      hospital: hospitalId
    });

    if (countryid) params.append("countryId", countryid);
    if (stateid) params.append("stateId", stateid);
    if (districtid) params.append("districtId", districtid);
    if (talukid) params.append("talukId", talukid);
    if (hobliid) params.append("hobliId", hobliid);
    // const response = await API.get(
    //   `/CMMIS/ccmis/GetInPatientDaycareDepartmentRevenue?startdate=${startDate}&enddate=${enddate}&hospital=${hospitalId}&countryId=${country}&stateId=${state}&districtId=${district}&talukId=${taluk}&hobliId=${hobli}`
    // );
    const response = await API.get(
      `/CMMIS/ccmis/GetInPatientDaycareDepartmentRevenue?${params.toString()}`
    );
    const apiData = response.data;

    // ✅ Normalize (optional but recommended)
    const finalData = apiData.map((item: any) => ({
      typeid: item.typeid,
      description: item.description,
      revenue: Number(item.revenue) || 0,
      count: Number(item.count) || 0
    }));

    const processedData = (() => {
      // If 'all' flag is true → return full data
      if (all) return finalData;

      // If <= 5 items → no need to group
      if (!finalData || finalData.length <= 5) return finalData;

      // Sort descending by revenue (important)
      const sorted = [...finalData].sort((a, b) => b.revenue - a.revenue);

      // Take top 4
      const top4 = sorted.slice(0, 4);

      // Remaining items
      const rest = sorted.slice(4);

      // Aggregate "Others"
      const others = {
        typeid: 0,
        description: "Others",
        revenue: rest.reduce((sum, item) => sum + item.revenue, 0),
        count: rest.reduce((sum, item) => sum + item.count, 0)
      };

      return [...top4, others];
    })();

    return {
      status: "success",
      isLoading: false,
      data: {
        success: true,
        message: "Patient details department retrived successfully",
        data: processedData,
        count: null,
        error: null
      },
      error: {}
    };

  } catch (err: any) {
    console.error(err);

    return {
      status: "error",
      isLoading: false,
      data: {
        success: false,
        message: "Failed to fetch patient department data",
        data: [],
        count: null,
        error: err
      },
      error: err
    };
  }
};

export const getPatientDiagnosisData = async (
  fromDate: any,
  toDate: any,
  hospitalId: any,
  countryid?: any,
  stateid?: any,
  districtid?: any,
  talukid?: any,
  hobliid?: any,
  all?: boolean,
) => {
  try {
    if (!hospitalId) {
      return null;
    }
    const startDate = dayjs(fromDate).format("YYYY-MM-DD");
    const enddate = dayjs(toDate).format("YYYY-MM-DD");
    const params = new URLSearchParams({
      startdate: startDate,
      enddate: enddate,
      hospital: hospitalId
    });

    if (countryid) params.append("countryId", countryid);
    if (stateid) params.append("stateId", stateid);
    if (districtid) params.append("districtId", districtid);
    if (talukid) params.append("talukId", talukid);
    if (hobliid) params.append("hobliId", hobliid);
    // const response = await API.get(
    //   `/CMMIS/ccmis/GetInPatientDaycareDepartmentRevenue?startdate=${startDate}&enddate=${enddate}&hospital=${hospitalId}&countryId=${country}&stateId=${state}&districtId=${district}&talukId=${taluk}&hobliId=${hobli}`
    // );
    const response = await API.get(
      `/CMMIS/ccmis/GetInPatientDaycareDiagnosisRevenue?${params.toString()}`
    );
    const apiData = response.data;

    // ✅ Normalize (optional but recommended)
    const finalData = apiData.map((item: any) => ({
      typeid: item.typeid,
      description: item.description,
      revenue: Number(item.revenue) || 0,
      count: Number(item.count) || 0
    }));

    const processedData = (() => {
      // If 'all' flag is true → return full data
      if (all) return finalData;

      // If <= 5 items → no need to group
      if (!finalData || finalData.length <= 5) return finalData;

      // Sort descending by revenue (important)
      const sorted = [...finalData].sort((a, b) => b.revenue - a.revenue);

      // Take top 4
      const top4 = sorted.slice(0, 4);

      // Remaining items
      const rest = sorted.slice(4);

      // Aggregate "Others"
      const others = {
        typeid: 0,
        description: "Others",
        revenue: rest.reduce((sum, item) => sum + item.revenue, 0),
        count: rest.reduce((sum, item) => sum + item.count, 0)
      };

      return [...top4, others];
    })();

    return {
      status: "success",
      isLoading: false,
      data: {
        success: true,
        message: "Patient details department retrived successfully",
        data: processedData,
        count: null,
        error: null
      },
      error: {}
    };

  } catch (err: any) {
    console.error(err);

    return {
      status: "error",
      isLoading: false,
      data: {
        success: false,
        message: "Patient details Diagnosis retrived successfully",
        data: [],
        count: null,
        error: err
      },
      error: err
    };
  }
};
// export const getPatientDiagnosisData = async (
//   fromDate: any,
//   toDate: any,
//   hospitalId: any
// ) => {
//   try {
//     if (!hospitalId) {
//       return null;
//     }
//     const startDate = dayjs(fromDate).format("YYYY-MM-DD");
//     const enddate = dayjs(toDate).format("YYYY-MM-DD");

//     const response = await API.get(`/CMMIS/ccmis/GetInPatientDaycareDiagnosisRevenue?startdate=${startDate}&enddate=${enddate}&hospital=${hospitalId}`
//     );

//     const apiData = response.data;

//     // ✅ Normalize (optional but recommended)
//     const finalData = apiData.map((item: any) => ({
//       typeid: item.typeid,
//       description: item.description,
//       revenue: Number(item.revenue) || 0,
//       count: Number(item.count) || 0
//     }));
//     console.log(finalData)
//     return {
//       status: "success",
//       isLoading: false,
//       data: {
//         success: true,
//         message: "Patient details Diagnosis retrived successfully",
//         data: finalData,
//         count: null,
//         error: null
//       },
//       error: {}
//     };

//   } catch (err: any) {
//     console.error(err);

//     return {
//       status: "error",
//       isLoading: false,
//       data: {
//         success: false,
//         message: "Failed to fetch patient diagnosis data",
//         data: [],
//         count: null,
//         error: err
//       },
//       error: err
//     };
//   }
// };

const generateStackedChartData = async (data: any) => {

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const labels = data.map((d: any) => `${monthNames[d.month - 1]}`);
  const yearLabels = data.map((d: any) => `${d.year}`);
  // let labels = data.map((item: any) => item.description)
  // Step 1: Collecting all unique staff type descriptions
  const allTypes = new Set<string>();
  data.forEach((location: any) => {
    location.details.forEach((staff: any) => {
      allTypes.add(staff.description);
    });
  });

  // console.log("allTypes-----", allTypes);

  // Step 2: Creating a map for each staff type with default count = 0
  const typeList: any = {};
  allTypes.forEach((type: any) => {
    typeList[type] = data.map((location: any) => {
      const staff = location.details.find((s: any) => s.description === type);
      return (staff ? staff.count : 0)
      // return {
      //   location: location.description,
      //   count: staff ? staff.count : 0,
      // };
    });
  });

  // console.log("typeList ---", typeList);
  // let label1 = Object.keys(typeList)[0]
  // let label2 = Object.keys(typeList)[1]
  // let consultantDoctor = typeList[label1]
  // let nurse = typeList[label2]

  let datasets = [];
  let backgroundColor = [
    '#4CBD9E', // unchanged
    '#F5B44B', // unchanged
    '#9172B3', // unchanged
    '#DC6375', // unchanged
    '#FFC23C', // unchanged
    '#008040', // unchanged
    '#FF9800', // unchanged
    '#E27C8B', // unchanged
    '#A8C4B3', // lighter green
    '#F48FB1', // lighter pink
    '#B39DFF', // lighter purple
    '#81D4FA', // lighter blue
    '#E0E0E0', // lighter grey
    '#A5D6A7'  // lighter green
  ];

  datasets = Object.keys(typeList).map((key: string, index: number) => {

    return {
      label: key,
      data: typeList[key],
      backgroundColor: backgroundColor[index], // Yellow
      borderRadius: 5, // ✅ Curved top & bottom
      borderSkipped: false, // ✅ Ensures both edges are rounded
      stack: 'Stack 0',
      barThickness: 50,
      // barThickness: 30, // Adjust thickness
    }
  })

  // console.log("datasets----", datasets);

  return { labels, datasets, yearLabels };
}
const getStackedChartOption = (yearLabels: any[], yText: string) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    barPercentage: 0.8, // ✅ Adjusts bar width
    categoryPercentage: 0.6, // ✅ Adds small gap between stacked bars
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxWidth: '10',
          pointStyleWidth: 14, // increases space between circle and label
          padding: 20
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        barPercentage: 0.9,
        categoryPercentage: 0.8,
        ticks: { color: '#666', },
        grid: { drawOnChartArea: false },
        border: {
          dash: [4, 4]
        }
      },
      xYears: {
        position: 'bottom',
        ticks: {
          callback: function (/* value: any, */ index: number) {
            // return index === 0 ? '2022' : index === 9 ? '2023' : ''; // ✅ Show years below months
            return index === 0 || yearLabels[index] !== yearLabels[index - 1] ? yearLabels[index] : '';
          },
          font: { weight: 'bold' },
          color: '#666',
        },

        grid: { drawOnChartArea: false },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: yText ? yText : 'Occupied Bed Days',
        },
        border: {
          dash: [4, 4]
        }
      },
    },
  }
}
export const getOverAllBedOccupancy = async (startdate?: any, toDate?: any, hospitalId?: any, facility?: any, patientType?: any) => {
  try {
    if (!hospitalId) {
      return null;
    }
    // const end = toDate ? dayjs(toDate) : dayjs();

    // If month >= April → FY starts this year
    // Else → FY starts last year
    // const fyStartYear = end.month() + 1 >= 4
    //   ? end.year()
    //   : end.year() - 1;

    // const startdate = dayjs(`${ fyStartYear }-04-01`).format("YYYY-MM-DD");
    const toDateTime = dayjs(toDate);
    const toDateFormatted = toDateTime.endOf("day").toISOString();
    const startDateTime = dayjs(startdate);
    const startdateFormatted = startDateTime.startOf("day").toISOString();

    // const startdate = dayjs(`${ fyStartYear }-04-01`);
    // const startdateFormatted = startdate.startOf("day").toISOString();
    // const response = await axiosInstance.get(apiUrlConstants.GET_OCCUPANCY_DATA, {
    //   params: { startdate: startdateFormatted, enddate: enddateFormatted, facilityManageType: facility },
    // });
    const response = await API.get(
      `/CMMIS/ccmis/GetFacilityTypeMonthlyOccupancyDetails?startdate=${startdateFormatted}&enddate=${toDateFormatted}&hospital=${hospitalId}&facilityManageType=${facility}&patienttype=${patientType}`
    );

    // const apiData = response.data;
    // console.log("getOverAllBedOccupancy response -->", response.data);
    let data = response.data

    const { labels, datasets, yearLabels } = await generateStackedChartData(data)

    const styledDatasets = datasets.map((ds: any) => ({
      ...ds,
      maxBarThickness: 35,     // ✅ Match Figma Design exactly
      // minBarLength: 2,           // Optional: ensures tiny values are visible
      borderRadius: 6,
      borderWidth: 1.5,
      borderColor: '#ffffff',
      borderSkipped: false,
    }));

    let chartData = {
      title: "Overall",
      labels,
      isStacked: true,
      datasets: styledDatasets,
      options: getStackedChartOption(yearLabels, 'Occupied Bed Days')
    }

    return chartData;
  } catch (err) {
    return console.error(err)
  }
}
export const getPatientDetailsDiagnosisGraphData = createAsyncThunk(
  "get/patient-details-diagnosis-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
      fromDate: any;
      toDate: any;
      hospitals: any;
      hospitalId?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post(
        `/CMMIS/cmmis/PatientDetailsDiagnosis?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}&fromDate=${data.fromDate}&toDate=${data.toDate}&hospitals=${data.hospitalId || ""}`,
        data?.hospitals
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
///////////////////////////////

export const getCustomersGraphData = createAsyncThunk(
  "get/customers-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: number;
      groupType: any
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/ccmis/ActiveHospitalsByCustomers?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}&groupType=${data?.groupType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
///////////////////////////////////////
export const getOnboardingSourceGraphData = createAsyncThunk(
  "get/onboarding-source-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/ccmis/ActiveHospitalsByOnboardingSource?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
/////////////////////////////////////////////////////

export const getActiveHospitalsGraphData = createAsyncThunk(
  "get/active-hospitals-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/cmmis/ActiveHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
/////////////////////////////
export const getExpiredAndDeactivatedHospitalsGraphData = createAsyncThunk(
  "get/expired-and-deactivated-hospitals-graph-data",
  async (
    data: {
      country: string;
      state: string;
      district: string;
      taluk: string;
      hobli: string;
      serviceType: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.get(
        `/CMMIS/cmmis/ExpiredAndDeActivatedHospitals?Country=${data.country}&State=${data.state}&District=${data.district}&Taluk=${data.taluk}&Hobli=${data.hobli}&serviceType=${data.serviceType}`
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          // window.location.href = routesName.errorPage;
        }
      }
      return rejectWithValue(error);
    }
  }
);
